"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var utilities_2 = require("../../../utilities/utilities");
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: ", ";\n  background-color: ", ";\n  padding: ", ";\n  font-size: ", ";\n"], ["\n  border-radius: ", ";\n  background-color: ",
    ";\n  padding: ", ";\n  font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return utilities_1.emphasizeColor(0.04, ((_b = theme.app) === null || _b === void 0 ? void 0 : _b.bgColor) || '#fff', true);
}, polished_1.rem(8), polished_1.rem(10));
var ExpandError = function (_a) {
    var className = _a.className;
    return react_1["default"].createElement(Wrapper, { className: className + " content-widget-expandError" }, utilities_2.__('Časť obsahu sa nepodarilo zobraziť. Skúste znovunačítať stránku.'));
};
exports["default"] = ExpandError;
var templateObject_1;
